import status from './status'
import statusChipColor from './statusChipColor'

export default {
  status,
  statusChipColor,
}
